import React from 'react';
import { PageTrackerWrapper } from 'queries/user/track';
import LockedPage from 'components/LockPage/Loadable';
import PyramideData from 'containers/PyramidesDesAges/Pyramide';
import { screenshotUrls } from 'containers/screenshotUrls';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { Outlet } from 'react-router-dom';

export const PyramidesDesAgesRoutes = {
  path: 'pyramides-des-ages',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.eleves.pyramideDesAges" />
      <Outlet />
    </>
  ),
  children: [
    {
      path: 'locked',
      element: (
        <PageTrackerWrapper title="Pyramides des âges - nope">
          <LockedPage
            featureKey="pyramidedesages"
            s3ImagePath={screenshotUrls.pyramideDesAges}
          />
        </PageTrackerWrapper>
      ),
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="Pyramides des âges">
          <PyramideData />
        </PageTrackerWrapper>
      ),
    },
  ],
};
